import { ModuleConfig } from "/@/cool";

export default (): ModuleConfig => {
	return {
		views: [
			{
				path: "/package/order",
				component: () => import("./views/package-order.vue"),
				meta: {
					label: "套餐下单",
					lang_key: "package_order"
				}
			}
		],
		async onLoad() {
			return {};
		}
	};
};
